
import { ModelBase } from "@models/UpsertableBase";
import { DataType, SourceBookType } from "@dndModels/Types";

export class SourceBook extends ModelBase {
  data_type: DataType = "source_book";
  abbreviation = "";
  is_free = false;
  third_party = false;
  is_public = false;
  is_archived = false;
  source_book_type: SourceBookType = "Source Book";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.abbreviation = obj.abbreviation ? obj.abbreviation : "";
      this.is_free = obj.is_free ? obj.is_free : (obj.public ? obj.public : false);
      this.third_party = obj.third_party ? obj.third_party : false;
      this.source_book_type = obj.source_book_type ? obj.source_book_type : (obj.homebrew ? "Homebrew" : "Source Book");
      this.is_public = obj.is_public ? obj.is_public : false;
      this.is_archived = obj.is_archived ? obj.is_archived : false;
      // if (this.source_book_type === "Unearthed Arcana") {
      //   debugger;
      // }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.abbreviation = obj.abbreviation ? obj.abbreviation : "";
  //     this.is_free = obj.is_free ? obj.is_free : (obj.public ? obj.public : false);
  //     this.third_party = obj.third_party ? obj.third_party : false;
  //     this.source_book_type = obj.source_book_type ? obj.source_book_type : (obj.homebrew ? "Homebrew" : "Source Book");
  //     this.is_public = obj.is_public ? obj.is_public : false;
  //     this.is_archived = obj.is_archived ? obj.is_archived : false;
  //     // if (this.source_book_type === "Unearthed Arcana") {
  //     //   debugger;
  //     // }
  //   }
  // }

  get homebrew() {
    return this.source_book_type === "Homebrew";
  }
  get hb() {
    return this.homebrew;
  }

  get ua() {
    return this.source_book_type === "Unearthed Arcana";
  }

  get blocked() {
    return !this.is_public;
  }
  get archived() {
    return this.is_archived;
  }
  get free() {
    return this.is_free;
  }

  get_detail_format(): string {
    let str = `${this.source_book_type}`;
    if (this.is_free) {
      str += "; Free";
    }
    if (this.third_party) {
      str += "; 3rd Party";
    }
    return str.trim();
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      abbreviation: this.abbreviation,
      is_free: this.is_free,
      third_party: this.third_party,
      source_book_type: this.source_book_type,
      is_public: this.is_public,
      is_archived: this.is_archived,
    };
  }

  copy(copyMe: SourceBook, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.abbreviation = copyMe.abbreviation;
    this.is_free = copyMe.is_free;
    this.third_party = copyMe.third_party;
    this.is_public = copyMe.is_public;
    this.is_archived = copyMe.is_archived;
    this.source_book_type = copyMe.source_book_type;
  }

  clone(drop_ids = false): SourceBook {
    const new_obj = new SourceBook();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}